import { render, staticRenderFns } from "./UsersForm.vue?vue&type=template&id=5bd6ab2b"
import script from "./UsersForm.vue?vue&type=script&lang=js"
export * from "./UsersForm.vue?vue&type=script&lang=js"
import style0 from "./UsersForm.vue?vue&type=style&index=0&id=5bd6ab2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports